import './app';
import './lock-scroll';
import './popup';
import anchorClick from './anchor';
import './counters';
import './form';
import share from './share';
import './popup-cookie';
import './animate';
import './facts';
import './projects';
import './team';
import './vacancies';
import './orientation';
import './photos';
import './photos-new';
import './vacancy';
import './invitation';
import {randomInteger} from './util';

$("body").addClass('_ready');
// if ($('#promo')) {
//     $('#promo').imagesLoaded( { background: true }, function() {
//         $("body").addClass('_ready');
//     });
// } else {
//     $("body").addClass('_ready');
// }

// подключаем svg для ie 11
svg4everybody();

// animate.css эффекты
new WOW().init();

if (!$('html').is('.mobile') && !$('html').is('.tablet') ) {
    $(".button").hover3d({
        selector: "> i",
        perspective: 100
    });

    $(".vacancies__item").hover3d({
        selector: ".vacancies__card"
    });

    $(".projects-slider__nav").hover3d({
        selector: ".projects-slider__nav-wrap",
        perspective: 70
    });

    if (window.navigator.userAgent.indexOf("MSIE ") > 0 || window.navigator.userAgent.indexOf("Edge") > 0) {} else{
        $('.vacancies__item').on("mousemove",function(e) {
            var ax = -($(this).innerWidth()/2- e.offsetX)/20;
            var ay = ($(this).innerHeight()/2- e.offsetY)/10;
            $(this).find('.vacancies__card-img-pattern').attr("style", "transform: translate("+ax/10+"%,"+ay/10+"%)");
            //$(this).find('.vacancies__card-img img:nth-child(2)').attr("style", "transform: scale(1.1) translate("+ax/10+"%,"+ay/10+"%)");
            //$(this).find('.vacancies__card-img-bg').css("background-position", (50 - ax) + "% " + (50 - ay) + "%");
        }).on("mouseout",function(e) {
            $(this).find('.vacancies__card-img-pattern').attr("style", "");
            //$(this).find('.vacancies__card-img img:nth-child(2)').attr("style", "");
            //$(this).find('.vacancies__card-img-bg').css("background-position", "50% 50%");
        });
    }

    $('.js-share').hover3d({
        selector: "> i",
        perspective: 10
    });

    $('.js-vacancy-citation-image').hover3d({
        selector: "> img",
        perspective: 200,
        sensitivity: 100
    });
}

//$('[style*="background-image:"]').imagesLoaded( { background: true }, function() {
//    console.log('#container background image loaded');
//});


// шэрилки
$('.js-share').click(function(e) {
    e.preventDefault();
    share[$(this).data('share')]();
});


// обработка меню
let $toggler = $('.js-menu-toggler');
$toggler.on('click', function () {
    $('html').toggleClass('menu-opened', $(this).find('input').prop('checked'));
});

$('.menu__links').on('click', 'a', function() {
    $('.js-menu-toggler input').prop('checked', false);
    $('html').toggleClass('menu-opened', $('.js-menu-toggler input').prop('checked'));
});


// темизация меню в зависимости от блока под ним
function sectionVisible(elem) {
    let coords = elem.getBoundingClientRect();

    //let windowHeight = document.documentElement.clientHeight;
    // верхняя граница elem в пределах видимости ИЛИ нижняя граница видима
    //let topVisible = coords.top > 0 && coords.top < windowHeight;
    //let bottomVisible = coords.bottom < windowHeight && coords.bottom > 0;
    //return topVisible || bottomVisible;

    let val = coords.height + coords.top;
    return val >= 60 && val <= coords.height + 60;
}
function menuTheme() {
    //let sections = document.querySelectorAll('.js-section');
    let sections = document.querySelectorAll('[data-menu]');
    for (let i = sections.length-1; i >= 0; i--) {
        if (sectionVisible(sections[i])) {
            //$('.js-header').toggleClass('_top', i == 0);
            $('.js-header').attr('data-theme', $(sections[i]).data('menu'));
            break;
        }
    }
    //$('.js-header').toggleClass('_fixed', $(window).scrollTop() >= 100);
    $('.js-header').toggleClass('_top', $(window).scrollTop() < 50);
}
$(window).on('scroll', function () {
    menuTheme();
});
menuTheme();

$('.js-logo').click(function(e) {
    if ($('.js-header').is('._top') && $(e.currentTarget).is('[data-redirect]')) {
        e.preventDefault();
        window.location.href = $(e.currentTarget).data('redirect');
    } else {
        anchorClick(e);
    }
});


// отложенная загрузка картинок после загрузки картинок в html
$('body').imagesLoaded( { background: true }, function() {
    $('img[data-src]').each(function() {
        // для блока "гордимся пректами" заменяем катринки для вертикально ориентированного планшета
        if ($(this).is('[data-src-tablet]') && device.tablet() && device.portrait()) {
            $(this).attr('src', $(this).data('src-tablet'));
        } else {
            $(this).attr('src', $(this).data('src'));
        }
    });
});


// для блока "гордимся пректами" заменяем катринки для вертикально ориентированного планшета
$(window).on('orientation:portrait', function() {
    $('img[data-src]').each(function() {
        $(this).attr('src', $(this).data('src-tablet'));
    });
});
$(window).on('orientation:landscape', function() {
    $('img[data-src]').each(function() {
        $(this).attr('src', $(this).data('src'));
    });
});

// загружаем рандомную картинку 404
$('.js-page-404-image').each(function () {
    const $img = $(this);
    const imgUrls = $img.data('src-random').split(',');
    const index = randomInteger(0,imgUrls.length - 1);

    this.src = imgUrls[index];

    window.onload = function() {
        $img.addClass('page-404-image-' + index);
    };
});

let xMousePos = 0;
let yMousePos = 0;
let lastScrolledLeft = 0;
let lastScrolledTop = 0;

let $photosSlider = $('.js-photos-slider-vacancy');
let $photosSlider2 = $('.js-slider-case');
let photosSliderOffset = $('.js-photos-slider-vacancy').offset();
let photosSliderOffset2 = $('.js-slider-case').offset();

$('.js-photos-slider-vacancy, .js-slider-case').mousemove(function () {
    $(this).addClass('cursor');
});

const throttle = (fn, throttleTime) => {
    let isThrottled = false

    return function() {
        if (isThrottled) return

        fn.apply(this, arguments)

        isThrottled = true
        
        setTimeout(function() {
            isThrottled = false
        }, throttleTime)

    }
};

// функции для того чтобы кастомный курсор возворащался в обычный вид при скролле
$(document).mousemove(function(event) {
    captureMousePosition(event);
});  

$(window).scroll(function() {
    scrollThrottle();
});

function captureMousePosition(event){
    xMousePos = event.pageX;
    yMousePos = event.pageY;
    window.status = "x = " + xMousePos + " y = " + yMousePos;
}

function scroll() {
    if(lastScrolledLeft != $(document).scrollLeft()){
        xMousePos -= lastScrolledLeft;
        lastScrolledLeft = $(document).scrollLeft();
        xMousePos += lastScrolledLeft;
    }
    if(lastScrolledTop != $(document).scrollTop()){
        yMousePos -= lastScrolledTop;
        lastScrolledTop = $(document).scrollTop();
        yMousePos += lastScrolledTop;
    }
    window.status = "x = " + xMousePos + " y = " + yMousePos;

    if(yMousePos < photosSliderOffset.top || yMousePos > photosSliderOffset.top + $photosSlider.outerHeight()) {
        $photosSlider.removeClass('cursor');
    } else {
        $photosSlider.addClass('cursor');
    }

    if(yMousePos < photosSliderOffset2.top || yMousePos > photosSliderOffset2.top + $photosSlider2.outerHeight()) {
        $photosSlider2.removeClass('cursor');
    } else {
        $photosSlider2.addClass('cursor');
    }
}

let scrollThrottle = throttle(scroll, 100);